<script lang="ts">
    import { Button, Col, Form, Input, Label, Row } from "sveltestrap";
    import { Add, Cancel, DropFiles, href, Note, Remove, SomeDetails, Uploadproject } from "../../../../utils/Constant/Constant";
    import Dropzone from "svelte-file-dropzone";
    let files = {
      accepted: [],
      rejected: []
    };

  function handleFilesSelect(e:any) {
    const { acceptedFiles, fileRejections } = e.detail;
    files.accepted = [...files.accepted, ...acceptedFiles];
    files.rejected = [...files.rejected, ...fileRejections];
  }
  function handleRemoveFile(e:any, index:number) {
    files.accepted.splice(index, 1);
    files.accepted = [...files.accepted];
  }
</script>
<Row>
    <Col>
        <div class="mb-3">
            <Label>{SomeDetails}</Label>
            <Input type="textarea" name="text" id="exampleText" rows={3} />
        </div>
    </Col>
</Row>
<Row>
  <Col>
    <div class="mb-3">
      <Label>{Uploadproject}</Label>
      <Dropzone on:drop={handleFilesSelect} multiple={false} >
        <i class="icon-cloud-up"></i>
        <h6>{DropFiles}</h6>
        <span class="note needsclick">{@html Note}</span>
      </Dropzone>
      <ol>
        {#each files.accepted as filesItem,index}
          <li>{filesItem.name}</li>
          <button on:click={e => handleRemoveFile(e, index)}>{Remove}</button>
        {/each}
      </ol>
    </div>
  </Col>
</Row>
<Row>
  <Col>
    <div class="text-end">
        <Button class="me-3" color="secondary" href={href}>{Add}</Button>
        <Button color="danger" href={href}>{Cancel}</Button>
    </div>
  </Col>
</Row>